import {
    Badge,
    classNames,
    CodeDigits,
    KeyPad,
    layout,
    PushButton,
    TextInput,
    theme,
    typography,
    useAsyncCallback,
    useTypeRef,
    View,
    ViewContent
} from "@variocube/cube-ui";
import * as React from "react";
import {useState} from "react";
import {stylesheet} from "typestyle";
import {VendingViewHeader} from "./header";
import {useLocalization} from "../i18n";

export interface CodeViewProps {
    onCode: (code: string) => Promise<void>;
    onCancel: () => void;
}

export function CodeView({onCode, onCancel}: CodeViewProps) {
    const {t} = useLocalization();
    const [code, setCode] = useState("");
    const [type, setType] = useTypeRef();

    const {loading, error, execute} = useAsyncCallback(async () => code && onCode(code), [onCode, code]);

    return (
        <View>
            <VendingViewHeader title="Bestellung abholen" onBack={onCancel}/>
            <ViewContent className={classNames(layout.vertical, layout.center, layout.alignCenter)}>
                <div className={classNames(layout.horizontal)}>
                    <div className={classNames(theme.moreContrast, styles.boxLeft)}>
                        <TextInput
                            type={"password"}
                            onChange={setCode}
                            value={code}
                            disabled={loading}
                            typeRef={setType}
                        />
                        <KeyPad onType={type} digits={CodeDigits} disabled={loading}/>
                    </div>
                    <div
                        className={classNames(theme.lessContrast, layout.vertical, layout.spaceBetween, styles.boxRight)}>
                        <div>
                            <div className={classNames(typography.title, layout.marginYSmall)}>
                                {t("EnterAccessCode")}
                            </div>
                            <div className={typography.description}>
                                {t("EnterCodeMessage")}
                            </div>
                        </div>

                        <div>
                            {loading && (
                                <p>{t("CodeChecking")}</p>
                            )}
                            {error && (
                                <p>
                                    <Badge error>
                                        {t("AccessCodeInvalid")}
                                    </Badge>
                                </p>
                            )}
                        </div>

                        <div>
                            <PushButton primary className={classNames(styles.button, styles.marginBottom)}
                                        onClick={execute}>
                                {t("Submit")}
                            </PushButton>
                        </div>
                    </div>
                </div>
            </ViewContent>
        </View>
    )
}

const styles = stylesheet({
    boxLeft: {
        width: "24em"
    },
    boxRight: {
        width: "20em",
        padding: "1.5em"
    },
    button: {
        width: "100%"
    },
    marginBottom: {
        marginBottom: "0.5rem"
    }
})
